module.exports = __webpack_public_path__ + "img/deco.6fb788d4.png";